"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.LoyaltyAPI = {
    getLoyaltyTiers: function (companyId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/loyalty").then(function (response) {
            var loyaltyTiers = response.data.data;
            return loyaltyTiers;
        });
    },
    addLoyaltyTier: function (companyId, createObject, updateAllCustomers) {
        if (updateAllCustomers === void 0) { updateAllCustomers = false; }
        var url = "/api/v1/company/" + companyId + "/loyalty?";
        if (updateAllCustomers) {
            url += 'updateAllCustomers=true&';
        }
        return index_1.axios.post(url, createObject).then(function (response) {
            var loyaltyTier = response.data;
            return loyaltyTier;
        });
    },
    editLoyaltyTier: function (companyId, loyaltyTierId, createObject, updateAllCustomers) {
        if (updateAllCustomers === void 0) { updateAllCustomers = false; }
        var url = "/api/v1/company/" + companyId + "/loyalty/" + loyaltyTierId + "?";
        if (updateAllCustomers) {
            url += 'updateAllCustomers=true&';
        }
        return index_1.axios.put(url, createObject).then(function (response) {
            var loyaltyTier = response.data;
            return loyaltyTier;
        });
    },
};
//# sourceMappingURL=LoyaltyAPI.js.map